exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.setting-auto-flow[data-v-76e1af8b] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 70%;\n  max-width: 1400px;\n  background: #fefefe;\n  padding: 16px;\n  z-index: 201;\n}\n.setting-auto-flow .title[data-v-76e1af8b] {\n    margin-bottom: 8px;\n    font-weight: 600;\n    font-size: 16px;\n}\n.setting-auto-flow .timeline[data-v-76e1af8b] {\n    margin-right: 8px;\n}\n.setting-auto-flow .setting-auto-flow-table-container[data-v-76e1af8b] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin-top: 16px;\n    height: calc(100% - 100px);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76e1af8b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/organisms/slidemenus/SettingApplicantBlacklist.vue
// module id = OJdm
// module chunks = 3